// src/components/StickyAudioPlayer.jsx
import React, { useState, useEffect } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';

import AuthUtility from '../frontend/auth/AuthUtility';
import { useAudio } from '../../context/AudioProvider';
import { useOffCanvas } from '../../context/OffCanvasProvider';
import AlbumsPanel from '../panels/AlbumsPanel';
import StickyBottomMemberNav from '../member/StickyBottomMemberNav';
import StickyBottomAdminNav from '../admin/StickyBottomAdminNav';

import $ from 'jquery'; // Import jQuery
import swal from 'sweetalert';

import go_to_icon from '../../assets/frontend/images/go_to_icon_2.png';

const StickyAudioPlayer = () => {
    const [progress, setProgress] = useState(0);
    const [authRole, setAuthRole] = useState(
        AuthUtility.isLoggedIn() ? localStorage.getItem('auth_role') : null
    );

    const {
        audioRef, tracklist, currentIndex, isPlaying, isPaused, playTrack,
        pause, resume, playNext, playPrev, likedMap, toggleLikeTrack,
        shuffle, shuffledOrder, generateShuffledOrder, toggleShuffle
    } = useAudio();

    const { push: openCanvas } = useOffCanvas();  //load offcanvas functions

    const track = tracklist && currentIndex !== null ? tracklist.tracks[currentIndex] : null;

    // COMPUTED isLiked (replaces the old useState)
    const safeLikedMap = likedMap || [];

    const likedTracksArray =
        Array.isArray(safeLikedMap.tracks)
            ? safeLikedMap.tracks
            : []; // normalize

    const isLiked =
        track && track.random_id
            ? likedTracksArray.some(item => item.random_id === track.random_id)
            : false;


    // Render sticky nav dynamically
    let StickyBottomNav = null;
    if (authRole === 'admin') StickyBottomNav = StickyBottomAdminNav;
    if (authRole === 'member') StickyBottomNav = StickyBottomMemberNav;

    useEffect(() => {
        const handleAuthChange = () => {
            setAuthRole(AuthUtility.isLoggedIn() ? localStorage.getItem('auth_role') : null);
        };

        AuthUtility.onAuthChange(handleAuthChange);

        return () => AuthUtility.offAuthChange(handleAuthChange);
    }, []);

    useEffect(() => {
        const audio = audioRef.current;
        const updateProgress = () => {
            const percent = (audio.currentTime / audio.duration) * 100;
            setProgress(percent);
        };
        audio.addEventListener('timeupdate', updateProgress);

        return () => audio.removeEventListener('timeupdate', updateProgress);
    }, []);

    function openAlbums(e) {
        e.stopPropagation();

        openCanvas({
            component: AlbumsPanel,
            props: {
                track: null,
                tracklist: null,
            }
        });
    }
    function forceBlur(e) {
        const target = e.currentTarget;

        // The button will lose focus after 1/2 seconds
        if (target) {
            setTimeout(() => {
                requestAnimationFrame(() => {
                    target.blur();
                });
            }, 500);
        }
    }

    return (
        <div className="sticky-bottom z-index-1010">
            <div className="sticky bg-000 ptb-10l-5s">

                <div className="panel large">

                    <div className="audio-timeline-container pb-5l-2s">
                        <audio ref={audioRef} onContextMenu={(e) => e.preventDefault()} />
                        <div className="audio-timeline"

                            onPointerDown={(e) => {
                                e.preventDefault();
                                const rect = e.currentTarget.getBoundingClientRect();
                                const updateTime = (clientX) => {
                                    const clickX = clientX - rect.left;
                                    const width = rect.width;
                                    audioRef.current.currentTime = (clickX / width) * audioRef.current.duration;
                                };

                                updateTime(e.clientX);

                                const moveHandler = (moveEvent) => updateTime(moveEvent.clientX);
                                const upHandler = () => {
                                    window.removeEventListener('pointermove', moveHandler);
                                    window.removeEventListener('pointerup', upHandler);
                                };

                                window.addEventListener('pointermove', moveHandler);
                                window.addEventListener('pointerup', upHandler);
                            }}
                        >
                            <div className="audio-timeline-progress" style={{ width: `${progress}%` }} />
                        </div>
                    </div>

                    {track ? (
                        <div className="horizontal-container justify-left gap-md-sm bb1-555 pb-5">
                            {tracklist.type == 'liked' || tracklist.type == 'playlist' ? (
                                track.image_url ? (
                                    <span className="center-everything b1-555">
                                        <img src={track.image_url} alt={tracklist.title} className="lighten-bright120per-contrast115per hide-for-small-only" width="50" />
                                        <img src={track.image_url} alt={tracklist.title} className="lighten-bright120per-contrast115per show-for-small-only" width="35" />
                                    </span>
                                ) : (
                                    <span className="center-everything b1-555">
                                        <img src={tracklist.image_url} alt={tracklist.title} className="lighten-bright120per-contrast115per hide-for-small-only" width="50" />
                                        <img src={tracklist.image_url} alt={tracklist.title} className="lighten-bright120per-contrast115per show-for-small-only" width="35" />
                                    </span>
                                )
                            ) : (
                                tracklist.image_url && (
                                    <span className="center-everything b1-555">
                                        <img src={tracklist.image_url} alt={tracklist.title} className="lighten-bright120per-contrast115per hide-for-small-only" width="50" />
                                        <img src={tracklist.image_url} alt={tracklist.title} className="lighten-bright120per-contrast115per show-for-small-only" width="35" />
                                    </span>
                                )
                            )}
                            <span className="pl-5">
                                <span className="font-orbitron font-size-18l-16m-14s font-weight-800 txt-fff letter-spacing-0px italic">{track.title}</span>
                                {track.type === 'demo' && (
                                    <span className="pl-5">
                                        <span className="font-poppins font-size-14 font-weight-400 txt-fff letter-spacing-0px italic">(Demo)</span>
                                    </span>
                                )}
                                {track.type === 'prod' && (
                                    <span className="pl-5">
                                        <span className="font-poppins font-size-14 font-weight-400 txt-fff letter-spacing-0px italic">(In Prod)</span>
                                    </span>
                                )}

                                {tracklist.type == 'liked' || tracklist.type == 'playlist' ? (
                                    <div className="font-orbitron font-size-16l-14s font-weight-400 txt-fff letter-spacing-0px italic uppercase pt-5">{track.tracklist_title ? track.tracklist_title : tracklist.title}</div>
                                ) : (
                                    <div className="font-orbitron font-size-16l-14s font-weight-400 txt-fff letter-spacing-0px italic uppercase pt-5">{tracklist ? tracklist.title : ''}</div>
                                )}
                            </span>
                            <span className="align-right">
                                <div className="horizontal-container justify-right">
                                    <span className="align-right">
                                        <button className={`player-button-transparent liked ${isLiked ? 'active' : ''}`}
                                            tabIndex="-1"
                                            onPointerDown={(e) => e.preventDefault()}
                                            onPointerUp={(e) => {
                                                e.stopPropagation();
                                                toggleLikeTrack(track, tracklist);

                                                // force blur on mobile
                                                forceBlur(e);
                                            }}
                                        >
                                        </button>
                                    </span>
                                </div>
                            </span>
                        </div>
                    ) : (
                        <div className='text-left bb1-555 pb-5'>
                            <span className="font-poppins font-size-18 font-weight-400 txt-fff letter-spacing-0px italic hide-for-small-only">No Track Loaded</span>
                            <span className="font-poppins font-size-14 font-weight-400 txt-fff letter-spacing-0px italic show-for-small-only">No Track Loaded</span>
                        </div>
                    )}

                    <div className="horizontal-container justify-center gap-lg-md mt-5">
                        <span className="align-left">
                            <button className={`player-button-transparent shuffle ${shuffle ? 'active' : ''}`}
                                tabIndex="-1"
                                onPointerDown={(e) => e.preventDefault()}
                                onPointerUp={(e) => {
                                    e.stopPropagation();
                                    toggleShuffle();
                                    // force blur on mobile
                                    forceBlur(e);
                                }}
                            >
                                {shuffle ? (
                                    <span className="font-poppins font-size-13 font-weight-500 pt-15">on</span>
                                ) : (
                                    <span className="font-poppins font-size-13 font-weight-500 pt-15">off</span>
                                )}
                            </button>
                        </span>
                        <span className="plr-20l-10s hide-for-small-only"></span>
                        <button className="player-button-transparent prev"
                            tabIndex="-1"
                            onPointerDown={(e) => e.preventDefault()}
                            onPointerUp={(e) => {
                                console.log("shuffle:", shuffle, "currentIndex:", currentIndex, "shuffledOrder:", shuffledOrder);
                                e.stopPropagation();

                                if (!tracklist || !tracklist.tracks?.length) {
                                    swal("Info", "An Album or Playlist Needs To Be Loaded.", "info");
                                    // force blur on mobile
                                    forceBlur(e);
                                    return;
                                }

                                playPrev();
                                // force blur on mobile
                                forceBlur(e);
                            }}
                        >
                        </button>
                        <span className="plr-10"></span>
                        {!isPlaying ? (
                            <button className="player-button-colored play"
                                tabIndex="-1"
                                onPointerDown={(e) => e.preventDefault()}
                                onPointerUp={(e) => {
                                    e.stopPropagation();

                                    console.log("playbutton - shuffle:", shuffle, "currentIndex:", currentIndex, "shuffledOrder:", shuffledOrder, 
                                        "isPlaying:", isPlaying, "isPaused:", isPaused);

                                    if (!tracklist || !tracklist.tracks?.length) {
                                        swal("Info", "An Album or Playlist Needs To Be Loaded.", "info");
                                        // force blur on mobile
                                        forceBlur(e);
                                        return;
                                    }

                                    // -------------------------
                                    // Shuffle-aware play logic
                                    // -------------------------
                                    if (shuffle) {
                                        // Only use shuffledOrder if we don't already have a current track
                                        if (shuffledOrder.length > 0) {
                                            const firstShuffledIndex = shuffledOrder[0];
                                            playTrack(firstShuffledIndex);
                                            // force blur on mobile
                                            forceBlur(e);
                                            return;
                                        } else {
                                            const order = generateShuffledOrder();
                                            if (order && order.length > 0) {
                                                const firstShuffledIndex = order[0];
                                                playTrack(firstShuffledIndex);
                                                // force blur on mobile
                                                forceBlur(e);
                                                return;
                                            } else {
                                                if (currentIndex === null || currentIndex === 0) {
                                                    const t = tracklist.tracks[0];
                                                    if (t && t.url) {
                                                        playTrack(0);
                                                        // force blur on mobile
                                                        forceBlur(e);
                                                        return;
                                                    }
                                                }
                                            }
                                        }
                                    }

                                    // -------------------------
                                    // Non-shuffle: play first active track if currentIndex is null
                                    // -------------------------
                                    if (currentIndex == null) {
                                        const idx = tracklist.tracks.findIndex(t => t.status === 'active');
                                        if (idx >= 0) {
                                            playTrack(idx);
                                            // force blur on mobile
                                            forceBlur(e);
                                            return;
                                        }
                                    }

                                    // -------------------------
                                    // Otherwise, play currentIndex
                                    // -------------------------
                                    const t = tracklist.tracks[currentIndex];
                                    if (t && t.url) {
                                        playTrack(currentIndex);
                                        // force blur on mobile
                                        forceBlur(e);
                                        return;
                                    }

                                    // -------------------------
                                    // Fallback: resume
                                    // -------------------------
                                    resume();
                                    // force blur on mobile
                                    forceBlur(e);

                                }}
                            >
                            </button>
                        ): (
                            isPaused && (
                            <button className="player-button-colored play"
                                tabIndex="-1"
                                onPointerDown={(e) => e.preventDefault()}
                                onPointerUp={(e) => {
                                    e.stopPropagation();

                                    console.log("playbutton - shuffle:", shuffle, "currentIndex:", currentIndex, "shuffledOrder:", shuffledOrder, 
                                        "isPlaying:", isPlaying, "isPaused:", isPaused);

                                    if (!tracklist || !tracklist.tracks?.length) {
                                        swal("Info", "An Album or Playlist Needs To Be Loaded.", "info");
                                        // force blur on mobile
                                        forceBlur(e);
                                        return;
                                    }

                                    resume();
                                    // force blur on mobile
                                    forceBlur(e);

                                }}
                            >
                            </button>
                            )
                        )}
                        {(isPlaying && !isPaused) && (
                            <button className="player-button-colored pause"
                                tabIndex="-1"
                                onPointerDown={(e) => e.preventDefault()}
                                onPointerUp={(e) => {
                                    e.stopPropagation();

                                    console.log("pausebutton - shuffle:", shuffle, "currentIndex:", currentIndex, "shuffledOrder:", shuffledOrder, 
                                        "isPlaying:", isPlaying, "isPaused:", isPaused);

                                    pause();
                                    // force blur on mobile
                                    forceBlur(e);
                                }}
                            >
                            </button>
                        )}
                        <span className="plr-10"></span>
                        <button className="player-button-transparent next"
                            tabIndex="-1"
                            onPointerDown={(e) => e.preventDefault()}
                            onPointerUp={(e) => {
                                console.log("shuffle:", shuffle, "currentIndex:", currentIndex, "shuffledOrder:", shuffledOrder);
                                e.stopPropagation();


                                if (!tracklist || !tracklist.tracks?.length) {
                                    swal("Info", "An Album or Playlist Needs To Be Loaded.", "info");
                                    // force blur on mobile
                                    forceBlur(e);
                                    return;
                                }

                                playNext();
                                // force blur on mobile
                                forceBlur(e);

                            }}
                        >
                        </button>
                        <span className="plr-10"></span>
                        <span className="align-right">
                            <Link onClick={openAlbums}>
                                <img src={go_to_icon} alt="Albums Icon" className="icon hide-for-small-only" style={{ width: '40px', height: '40px', marginRight: '0' }} />
                                <img src={go_to_icon} alt="Albums Icon" className="icon show-for-small-only" style={{ width: '35px', height: '35px', marginRight: '0' }} />
                            </Link>
                        </span>
                    </div>

                </div>

                {/* Sticky nav updated dynamically */}
                {StickyBottomNav && <StickyBottomNav />}

            </div>
        </div >
    );
};

export default StickyAudioPlayer;